module.exports = __webpack_public_path__ + "static/img/charles59_Japanese_handsome_male_model_white_background_bright__134dc224-ae3f-4c52-8a34-eaa949f3e1a1.25855b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/charles59_Japanese_handsome_male_model_white_background_bright__134dc224-ae3f-4c52-8a34-eaa949f3e1a1.png
// module id = vJI6
// module chunks = 0